<template>
  <div class="content-box content-normal">
    <h3>更换手机号码</h3>
    <form action="javascript:;" class="common-form" @submit.prevent="save">
      <div class="form-grop text">
        <label for="phone">
          <span class="icon">
            <phone-icon/>
          </span>
          手机号码
        </label>
        <input
          id="phone"
          placeholder="请输入手机号"
          v-model.trim="form.phone"
          type="text"
        >
      </div>
      <div class="form-grop text with-btn">
        <label for>
          <span class="icon">
            <code-icon/>
          </span>
          验证码
        </label>
        <div class="input">
          <input
            id="capcha"
            v-model.trim="form.captcha"
            placeholder="请输入验证码"
            type="text"
          >
          <countdown-btn
            el="div"
            ref="countdownBtn"
            id="capchaBtn"
            class="right-btn"
            :time="60"
            @click="getCapcha"
          />
        </div>
      </div>
      <button class="submit" type="submit">关联</button>
      <p>关联过程中您如有任何疑问均可直接在微信公众号留言咨询。</p>
    </form>
  </div>
</template>
<script>
import CountdownBtn from '@/components/CountdownBtn'
import PhoneIcon from '@/assets/svg/form/phone.svg'
import CodeIcon from '@/assets/svg/form/code.svg'
import { put } from '@/utils/ajax'
import { required, phone, validationMixin } from '@/utils/mixin_validate'
export default {
  mixins: [validationMixin()],
  data() {
    return {
      form: {
        phone: '', // 这里的手机号指的是家长手机号
        captcha: ''
      }
    }
  },
  validations: {
    form: {
      phone: {
        required,
        phone
      },
      captcha: {
        required
      }
    }
  },
  validators: {
    form: {
      phone: {
        required: '手机号必填'
      },
      captcha: {
        required: '验证码必填'
      }
    }
  },
  methods: {
    async save() {
      const {
        form: { phone, captcha }
      } = this
      await this.validationTouch()
      await put('/edu/wap/profiles/users/mobile', { mobile: phone, captcha })
      this.$store.commit('SET_USER', { mobile: phone })
      this.$message.success('手机号更换成功')
      this.$router.push({ name: 'user' })
    },
    async getCapcha(lock, reset) {
      if (!this.form.phone) {
        this.$message('请先填写手机号')
        return reset()
      }
      this.$verify({
        identity: this.form.phone,
        dom_id: 'capchaBtn',
        success_callback: this.sendCapcha,
        fail_callback: reset,
        close_callback: reset
      })
    },
    async sendCapcha(ticket) {
      const countdownBtn = this.$refs.countdownBtn
      try {
        await this.$auth('send_universal_captcha', this.form.phone, ticket)
        this.$message.success('验证码已发送至手机')
        countdownBtn.lock()
      } catch (error) {
        countdownBtn.reset()
      }
    }
  },
  components: {
    CountdownBtn,
    PhoneIcon,
    CodeIcon
  }
}
</script>
<style lang="stylus" scoped>
h3
  font-size 18px
  text-align center
  margin-top 40px
  margin-bottom 40px
  font-weight normal
</style>
